import React from 'react'
import CardUI from '../../widgets/layout/CardUI'
import FormSF from '../../widgets/form/FormSF'
import InputSelectUI from '../../widgets/form/InputSelectUI'
import InputPhoneNumberUI from '../../widgets/form/InputPhoneNumberUI'
import './SignUp.css'

const SignUpWithPhoneUI = ({context, messageList, onSubmit, submitted, successMsg, errorList, setErrorList,
    // phone number
    phoneNumber, onPhoneNumberChange, phoneNumberError, setPhoneNumberError,
    // country code
    countryCode, onCountryCodeChange, countryCodeError, countryList,
  }) =>
  <CardUI context={context}>
    <FormSF context={context} className='pub_signup' messageList={messageList} buttonMessageKey='c_sign_up'
        onSubmit={onSubmit} successMsg={successMsg} errorList={errorList} setErrorList={setErrorList}
        busy={submitted}>
      <InputPhoneNumberUI name='phoneNumber' required={true}
        messageList={messageList} labelKey='c_phone_number' helpKey='c_tip_verify_phone'
        value={phoneNumber} onChange={onPhoneNumberChange}
        error={phoneNumberError} setError={setPhoneNumberError}
      />
      <InputSelectUI name='countryCode' required={true}
        messageList={messageList} labelKey='c_country'
        value={countryCode} optionList={countryList}
        onChange={onCountryCodeChange} error={countryCodeError}
      />
    </FormSF>
  </CardUI>

export default SignUpWithPhoneUI
